//创建一个zustand仓库，只用于保存音乐的like状态，和音乐的id，因为是用于所有音乐的，id和like的关系要用map<id, like>数据结构来实现
import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { enableMapSet } from 'immer'

import type { MusicOptionsStore } from './types'

enableMapSet()

export const useMusicOptionsStore = create<MusicOptionsStore>()(
  immer((set, get) => ({
    likeMap: new Map(),
    setLikeStatus: (id, likeStatus) => {
      set((state) => {
        state.likeMap.set(id, likeStatus)
      })
    },
    reset: () => {
      set((state) => {
        state.likeMap.clear()
      })
    },
  })),
)
